import { style } from "@vanilla-extract/css";
import { primitiveTokens, semanticThemeTokens } from "../theme/ThemeTokens.css";

export const toggleGroup = style({
  display: "inline-flex",
  gap: primitiveTokens.sizing["1x"]
});

export const toggleItem = style({
  fontSize: primitiveTokens.type.xs,
  padding: `2px ${primitiveTokens.sizing["2x"]}`,
  borderRadius: primitiveTokens.radii.sm,
  border: `${primitiveTokens.borderWidth.default} solid`,
  borderColor: semanticThemeTokens.toggleGroup.item.borderColor,
  cursor: "pointer",
  background: "transparent",
  color: "inherit",
  transition: `background-color ${primitiveTokens.transitionDuration.default} ease, border-color ${primitiveTokens.transitionDuration.default} ease`,
  selectors: {
    "&:focus-visible": {
      boxShadow: semanticThemeTokens.toggleGroup.item.focus.boxShadow,
      outline: semanticThemeTokens.toggleGroup.item.focus.outline
    },
    "&:hover:not([data-state='on']):not([data-disabled])": {
      backgroundColor:
        semanticThemeTokens.toggleGroup.item.hover.backgroundColor
    },
    "&[data-state='on']": {
      backgroundColor:
        semanticThemeTokens.toggleGroup.item.selected.backgroundColor,
      borderColor: semanticThemeTokens.toggleGroup.item.selected.borderColor,
      color: semanticThemeTokens.toggleGroup.item.selected.textColor
    },
    "&[data-disabled]": {
      cursor: "default",
      opacity: 0.5
    }
  }
});
